import React from "react";
import { ChatBubbleBottomCenterTextIcon, UserIcon, ClockIcon } from "@heroicons/react/24/outline";

export default function HelpDesk() {
  return (
    <div className="min-h-screen bg-gray-100 px-4 py-6 md:px-10" style={{ fontFamily: "Poppins, Roboto, sans-serif" }}>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Help Desk</h1>
        <p className="text-gray-600 text-sm mt-1">
          Manage and resolve customer support tickets
        </p>
      </div>

      <div className="bg-white shadow rounded-xl p-6">
        <div className="flex items-center gap-4 mb-6">
          <ChatBubbleBottomCenterTextIcon className="h-8 w-8 text-indigo-600" />
          <div>
            <h2 className="text-xl font-semibold">Ticket Management</h2>
            <p className="text-gray-600">Handle open and in-progress tickets</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-blue-50 p-4 rounded-lg">
            <div className="flex items-center gap-3 mb-2">
              <ClockIcon className="h-6 w-6 text-blue-600" />
              <h3 className="font-semibold text-blue-900">Open Tickets</h3>
            </div>
            <p className="text-blue-700">View and manage all open support requests</p>
          </div>

          <div className="bg-yellow-50 p-4 rounded-lg">
            <div className="flex items-center gap-3 mb-2">
              <UserIcon className="h-6 w-6 text-yellow-600" />
              <h3 className="font-semibold text-yellow-900">In Progress</h3>
            </div>
            <p className="text-yellow-700">Track tickets currently being resolved</p>
          </div>

          <div className="bg-green-50 p-4 rounded-lg">
            <div className="flex items-center gap-3 mb-2">
              <ChatBubbleBottomCenterTextIcon className="h-6 w-6 text-green-600" />
              <h3 className="font-semibold text-green-900">Communication</h3>
            </div>
            <p className="text-green-700">Chat and communicate with customers</p>
          </div>
        </div>

        <div className="mt-8 p-4 bg-gray-50 rounded-lg">
          <p className="text-gray-600 text-center">
            This is the Help Desk interface where agents can manage open and in-progress tickets.
            <br />
            Full ticket management functionality would be implemented here.
          </p>
        </div>
      </div>
    </div>
  );
}